module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GL-8250ff7477845fe0485f11d373202f54.png";